import { Color } from '@tmh-website/shared/colors';
import type { ButtonHoverThemeColor, ButtonThemeColor } from '@tmh-website/ui/Button';
import type { FormElementThemeColor } from '@tmh-website/ui/FormElements';

import type { FormThemeColor } from './Form.types';

export interface FormTheme {
  background: Color;
  text: Color;
  formElementThemeColor: FormElementThemeColor;
  buttonThemeColor: ButtonThemeColor;
  buttonHoverThemeColor: ButtonHoverThemeColor;
}

export const formThemes: Record<FormThemeColor, FormTheme> = {
  [Color.Blue_1000_Deep]: {
    background: Color.Blue_1000_Deep,
    text: Color.Neutral_0_White,
    formElementThemeColor: Color.Blue_1000_Deep,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme, based on the TMH styleguide.
   *
   * @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-374
   */
  [Color.Green_1000_Energy]: {
    background: Color.Green_1000_Energy,
    text: Color.Neutral_0_White,
    formElementThemeColor: Color.Green_1000_Energy,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Neutral_0_White,
  },

  [Color.Neutral_0_White]: {
    background: Color.Neutral_0_White,
    text: Color.Neutral_1000_Black,
    formElementThemeColor: Color.Neutral_0_White,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
  },
  [Color.Neutral_200_OffWhite]: {
    background: Color.Neutral_200_OffWhite,
    text: Color.Neutral_1000_Black,
    formElementThemeColor: Color.Neutral_200_OffWhite,
    buttonThemeColor: Color.Blue_500_Ultramarine,
    buttonHoverThemeColor: Color.Blue_1000_Deep,
  },
};
